export default function DtRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Dragon Tiger</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20"> Payout as per the bet placed </p>
                                                    <table class="table table-bordered table-sm">

                                                        <tbody>
                                                            <tr>
                                                                <th>Dragon</th>
                                                                <th>1 : 0.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Tiger</th>
                                                                <th>
                                                                    1 : 0.98
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Tie (Rank Only)	</th>
                                                                <th>
                                                                    1 : 10
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Even</th>
                                                                <th>
                                                                    1 : 1.1
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Odd</th>
                                                                <th>
                                                                    1 : 0.8
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Red</th>
                                                                <th>1 : 0.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Black</th>
                                                                <th>
                                                                    1 : 0.98
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Suit</th>
                                                                <th>
                                                                    1 : 2.75
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">The primary goal of this game is to predict the outcome of a face-off between two hands: Dragon and Tiger. In addition to guessing the winner, players can also place bets on whether the Dragon and Tiger hands will tie in terms of card value. </p>

                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"> <b>Dealing Hands: </b>  At the start of the game, two hands are dealt – one for Dragon and the other for Tiger.</p>
                                            <p class="pt20"><b>Betting Choices:</b> Players place bets on the outcome of the game. They can wager on which of the two hands, Dragon or Tiger, will have a higher card value.</p>
                                            <p class="pt20"><b>Tie (Rank only):</b> Alternatively, they can bet on a tie between the two hands, specifically if the numerical rank of the cards is the same.</p>
                                            <p class="pt20"><b>Number Ranking:</b>The cards are ranked from lowest to highest: Ace, 2, 3, 4, 5, 6, 7, 8, 9, 10, Jack, Queen, and King. In this ranking, Ace is considered the lowest card with a value of 1, while King is the highest card with a value of 13.</p>

                                        </div>
                                    </center>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}